export const UpdatePhasingDataSource = (phasingData) => {
  return {
    type: 'PHASING_DATA',
    payload: phasingData
  };
};

export const UpdatePhasingType = (type) => {
  return {
    type: 'PHASING_TYPE',
    payload: type
  };
};
